import config from '../config';
import React,{Component} from "react";
import Cookies from "universal-cookie"
import "../scss/general.css";
import NumberFormat from 'react-number-format';
import logo from "./images/loading.gif";
import "../scss/radio.scss" ;
import Mymodal from './modal';
import BusyModal from "./modalwait";
const axios = require("axios");
const ref = React.createRef();
const cookies=new Cookies();
const initialState={

    input:{reading:0,nextreading:0},myitems:[],card:[],bdisabled:false,isLoaded:false,inputkey:Date.now() ,errors:{},error:"",ErrMsg:<img src={logo} alt=""/>,errorcss:"labelerror",imagefile:config.Appdir+"/images/NoImage.png",filetoupload:null,filename:null,browsecss:"labelblock",FleetCard:"",errorimg:"",
        waitfooter:"",ErrMsg2:"",closefooter:<button onClick={()=>{this.hideModal}}>Close</button>
}

class EnginOil extends Component{
    constructor(props)
    {
        super(props);
            this.state=initialState;
           this.handleChange = this.handleChange.bind(this);
           this.handleSubmit = this.handleSubmit.bind(this);    
           this.handleClear = this.handleClear.bind(this);
    }
    handleClear(){
        let input=this.state.input;
        input["reading"]=0;
        input["nextreading"]=0;
        this.setState({ErrMsg2:"",input});
    }
    componentDidMount(){
/*        this.setState({ErrMsg:<img source ={logo} alt=''/>,ErrMsg2:"" });
        this.componentDidMountLoad();
    }
    componentDidMountLoad()
    {*/
        let id=cookies.get("LoginID");
        if(id.length > 1)
        {
            document.body.style.cursor="wait";
        }

        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/userv/get_fleetcard/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {

            document.body.style.cursor="default";
            let input=this.state.input;
            input["vehicle"]=response.data[0]["vehnum"];
            input["fleetcard"]=response.data[0]["fleetcard"];
            input["emp_id"]=id;

            this.setState({isLoaded: true, myitems: response.data,input,ErrMsg:""});
        })
        .catch(()=> {
            //handle error
            this.setState({ErrMsg:""});
        }); 
    }
    handleChange=(event)=> 
    {
        
        this.setState({imagefile:this.state.defaultimage});
    }

    handleSelectChange=(event)=>
    {
        let input = this.state.input;
        let fleetcard=event.target.value;
        let index = event.nativeEvent.target.selectedIndex;
        let label = event.nativeEvent.target[index].text;
        input[event.target.name]=label;
        input["fleetcard"]=fleetcard;
        let flimit="";

        this.setState({FleetCard:fleetcard,input});
    }

    
    //Change of input fields
    handleFiledsChange=(event)=>
    {
        let input = this.state.input;
        if(event.target.name==="tdate")
            {input[event.target.name]=event.target.value;}
        else        
            input[event.target.name]=event.target.value;
        this.setState({input});  
    }
    handleFocus=(e)=>{e.target.select();}

    handleSubmit = (event)=>{
        event.preventDefault();
        this.setState({ErrMsg2:<BusyModal/>});
        console.log(this.state.input);
        this.setState({errorprofile:""});
        if(this.validate())
        {
            document.body.style.cursor="wait";
            axios({
               method: 'post',
                url: cookies.get("phpclass")+'/index.php/userv/Addenginoil/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
                })

                .then((response)=> {
                    console.log(response.data);
                    document.body.style.cursor="default";
                    if(response.data ===1)
                    {   
                        document.body.style.cursor="default";
                        this.setState({ErrMsg2:<Mymodal  handler = {this.handleClear} Type="1" Title={config.gvr.ErrMsgs.TitleSuccess} Body={config.gvr.ErrMsgs.MsgSuccess}/>});
                    }
                    else
                    {
                        document.body.style.cursor="default";
                        this.setState({ErrMsg2:<Mymodal  handler = {this.handleClear} Type="0" Title={config.gvr.ErrMsgs.TitleUnknown} Body={config.gvr.ErrMsgs.MsgUnknown}/> });
                    }
                })
                .catch((response)=> {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg2:<Mymodal  handler = {this.handleClear} Type="0" Title={config.gvr.ErrMsgs.TitleUnknown} Body={config.gvr.ErrMsgs.MsgUnknown}/> });
                }); 
        }
        else
            this.setState({ErrMsg2:""});

            
    }
    validate(){
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        console.log(input);
          //For Employee code
          //For password
          if(!input["mode"])
          {
              isValid=false;
              errors["pmode"]="Please select mode of payment.";
          }
          //For Confirm password
          if(!input["tdate"]){
              isValid=false;
              errors["pdate"]="Please enter date.";
          }
  
          if(!input["reading"]){
              isValid=false;
              errors["preading"]="Please enter current reading.";
          }
          if(!input["nextreading"]){
              isValid=false;
              errors["nreading"]="Please enter next due date.";
          }
          if(input["nextreading"]<=input["reading"]){
              isValid=false;
              errors["nreading"]="Invalid next due reading.";
          }

          this.setState({
            errors: errors
          });
      
          return isValid;
      }        
      render(){
//        let items = this.state.myitems;
        let isLoaded = this.state.isLoaded;
        let myItem = this.state.myitems;
        if(!this.state.isLoaded) 
        { 
            return (
                   <div className="container1">


                    <div className="center" style={{textAlign:"center"}}>
                          {this.state.ErrMsg}
                    </div>
                    </div>
            )
        } 
        else 
        {
        return(      
            <div className="container1">

          <div className="auth-wrapper">
                
                <div className="inner-profile">
                <p style={{textAlign:"center", width:"100%",fontWeight:"bold"}}>ENGINE OIL</p>

                <br></br>

                <form >
                    
                    <div className="inner-v2">

                        <div className="form-group row" >
                            <label style={{paddingLeft:2}}>Vehicle <font style={{color:"red"}}>*</font></label>
                            <select id="vehicle" name="vehicle" style={{height:30,borderRadius:15}} onChange={this.handleSelectChange} >
                                {myItem.map((result,i)=>{
                                    return(
                                        <option value={result.fleetcard} key={i}  >{result.vehnum}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <br></br>

                        <div className="form-group row">
                            <label style={{paddingLeft:2}}>Mode of payment <font style={{color:"red"}}>*</font></label>
                            <input type="radio" className="radio" id="mode1" name="mode" value="Fleet Card" onClick={this.handleFiledsChange}/>
                            <label htmlFor="mode1" className="label">
                                Card
                            </label>
                            <label style={{width:"10px"}}>
                            </label>
                            <input type="radio" id="mode2" name="mode" className="radio" value="Cash" onClick={this.handleFiledsChange}/>
                            <label htmlFor="mode2" className="label">
                                Cash
                            </label>
                            <small id="mode" name="mode" className="text-danger">{this.state.errors.pmode}</small>
                        </div>
                        <br></br>
                        <div className="form-group row">
                            <label style={{paddingLeft:2}}>Fleet Card#</label>
                            <NumberFormat format="####-####-####-####" value={this.state.input["fleetcard"]} name="fleetcard" id="fleetcard" className="form-control" required size="16" style={{borderRadius:15,height:30,width:"70%"}} disabled />
                            <small id="plimit" name="plimit" >{this.state.fuellimit}</small>

{/*}                            <button className=".btn btn-secondary btn-sm" onClick={this.handleSave} disabled={this.state.RbuttonED} style={{width:"15px",height:"15px",marginTop:"8px"}}>
                                -</button>*/}
                        </div>
                    </div>            

                    <div className="inner-v3" >
                        <div className="form-group row">
                            <label style={{paddingLeft:2}}>Date <font style={{color:"red"}}>*</font> </label>
                            <input type="date" name="tdate" id="tdate" className="form-control" style={{borderRadius:15,height:30}} onBlur={this.handleFiledsChange}/>
                            <small id="pdate" name="pdate" className="text-danger">{this.state.errors.pdate}</small>
                        </div>
                        <br></br>

                        <div className="form-group row">
                            <label style={{paddingLeft:2}}>Meter reading</label>
                            <input type="number" name="reading" style={{textAlign:"right",width:100,height:30,borderRadius:15}} value={this.state.input["reading"]} className="form-control" onFocus={this.handleFocus} onChange={this.handleFiledsChange}/>
                            <small id="preading" name="preading" className="text-danger">{this.state.errors.preading}</small>
                        </div>
                        <br></br>

                        <div className="form-group row">
                            <label style={{paddingLeft:2}}>Next due reading</label>
                            <input type="number" name="nextreading" style={{textAlign:"right",width:100,height:30,borderRadius:15}} value={this.state.input["nextreading"]} className="form-control" onFocus={this.handleFocus} onChange={this.handleFiledsChange}/>
                            <small id="nreading" name="nreading" className="text-danger">{this.state.errors.nreading}</small>
                        </div>
                        <div className={this.state.errorcss} style={{textAlign:"right"}}>
                    <button type="submit" className="btn btn-dark" disabled={this.state.bdisabled} onClick={this.handleSubmit} >Submit</button><br/>
                    <span>{this.state.errorprofile }</span>
                </div>

                    </div>
                </form>
                
{/*}        <Modal show={this.state.isOpen} onHide={this.onhideModal} animation="false" centered backdrop="static" size={this.state.modalsize}>
        <Modal.Body><img src={this.state.errorimg} width="20px" height="20px"/>{this.state.error}<br/><br/>
          {this.state.modalfooter}</Modal.Body>
      </Modal>
*/}
           </div>        
                            
            {this.state.ErrMsg2}
            </div>            
    </div> 
          );}
    }}
export default EnginOil;